<div
  [style.justify-content]="votingEnabled ? 'flex-start' : 'center'"
  [class.vote-disabled-text]="!votingEnabled"
  class="d-flex flex-column align-items-center"
>
  <ng-container *ngIf="votingEnabled">
    <app-vote-section #senateSection
                      (voteEmitter)="addSenateVotes($event)"
                      [options$]="votingService.senateOptions$" [type]="1"></app-vote-section>
    <!--<div class="separator-bar"></div>-->
    <app-vote-section #councilSection
                      (voteEmitter)="addCouncilVotes($event)"
                      [options$]="votingService.councilOptions$"
                      [type]="2"></app-vote-section>
    <p class="ma-abtin-warning">Nu uita că opțiunea <span>"Mă abțin"</span> este selectată <span>implicit!</span></p>
    <app-button (action)="sendVotes()" [disabled]="votingService.count > totalLength" [loading]="loading"
                [type]="votingService.count > totalLength ? 'disabled' : 'blue-filled'"
                class="mb-4" label="Trimitere vot" textType="big" type="blue-filled"></app-button>
    <p (click)="reset()" class="reset-options">Resetare opțiuni</p>
  </ng-container>
  <ng-container *ngIf="!votingEnabled">
    <p class="text-center not-started-text">Alegerile <span>s-au incheiat!</span> Mulțumim <span>pentru voturi!</span>.</p>
  </ng-container>
</div>

